import { watch, Ref } from "vue";

export const useSaveWorkspaceWatcher = (
  activeAppliedFilter: Ref<any>,
  activeUserColumns: Ref<any>,
  appliedFilters: Ref<any>,
  showSaveWorkspaceButton: Ref<boolean>
) => {
  watch(
    [activeAppliedFilter, activeUserColumns, appliedFilters],
    ([newActiveFilters, newColumns, newAppliedFilters], [oldActiveFilters, oldColumns, oldAppliedFilters]) => {
      const hasActiveAppliedFilters = newActiveFilters && Object.keys(newActiveFilters).length > 0;
      const hasAppliedFilters = newAppliedFilters && Object.keys(newAppliedFilters).length > 0;
      const activeAppliedFiltersChanged =
        newActiveFilters && oldActiveFilters && newActiveFilters !== oldActiveFilters && hasActiveAppliedFilters;
      const appliedFiltersChanged =
        newAppliedFilters && oldAppliedFilters && newAppliedFilters !== oldAppliedFilters && hasAppliedFilters;
      const columnsChanged = newColumns && oldColumns && JSON.stringify(newColumns) !== JSON.stringify(oldColumns);

      showSaveWorkspaceButton.value =
        hasActiveAppliedFilters ||
        hasAppliedFilters ||
        activeAppliedFiltersChanged ||
        appliedFiltersChanged ||
        columnsChanged;
    },
    { deep: true }
  );
};
